import {Card, ListGroup} from "react-bootstrap";
import React from "react";

const RideSummaryCard = (props) => {
    return (
        <Card className="calendar-fit m-1">
            <Card.Header className="text-center">{props?.title}</Card.Header>
            <Card.Body>
                <ListGroup className="list-group-flush">
                    <ListGroup.Item>Date: {props?.date}</ListGroup.Item>
                    <ListGroup.Item>Distance [km]: {props?.distance} </ListGroup.Item>
                    <ListGroup.Item>Moto Commute: {props?.motoCommute}</ListGroup.Item>
                </ListGroup>
            </Card.Body>
        </Card>
    )
}

export default RideSummaryCard;